import { css } from "lit";

export const buttonStyles = css`
    .btn {
        display: inline-block;
        font-weight: 700;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: .125rem solid transparent;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 50rem;
        text-transform: uppercase;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .btn-block {
        display: block;
        width: 100%;
    }

    .btn-lg {
        padding: 0.5rem 1rem;
        font-size: 1.25rem;
        line-height: 1.5;
    }

    .btn-ts-primary {
        background-color: var(--ts-color-secondary--darkest);
        border-color: var(--ts-color-secondary--darkest);
        color: #fff;
    }

    .btn-ts-primary:hover,
    .btn-ts-primary:active {
        background-color: var(--ts-color-secondary);
        border-color: var(--ts-color-secondary);
        color: var(--ts-color-secondary--darkest);
    }

    .btn-ts-link {
        color: var(--color-body);
        background-color: transparent;
        border-color: var(--color-body); }
        .btn-ts-link:hover, .btn-ts-link:focus {
            color: white !important;
            background-color: var(--color-body) !important;
            border-color: var(--color-body) !important; }
    
    .btn-ts-white {
        color: var(--color-body);
        background-color: white;
        border-color: white; }
        .btn-ts-white:hover, .btn-ts-white:focus {
            color: var(--color-body) !important;
            background-color: var(--color-whitesmoke) !important;
            border-color: var(--color-whitesmoke) !important; }
`;
